/* Only play an opted-in muted preview while it is visible; retain native controls. */
(() => {
  const connect = (scope) => {
    scope.querySelectorAll('[data-glow-video]:not([data-video-ready])').forEach((video) => {
      video.dataset.videoReady = 'true';
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = false;
      video.addEventListener('pointerdown', () => { userPaused = !video.paused; });
      video.addEventListener('keydown', () => { userPaused = !video.paused; });
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && !motion.matches && !userPaused) video.play().catch(() => {});
        else if (!entry.isIntersecting) video.pause();
      }, { threshold: 0.5 });
      observer.observe(video);
      const onMotion = () => { if (motion.matches) video.pause(); };
      motion.addEventListener('change', onMotion);
      const unload = (event) => {
        if (!event.target.contains(video)) return;
        observer.disconnect(); video.pause(); motion.removeEventListener('change', onMotion);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  connect(document);
  document.addEventListener('shopify:section:load', (event) => connect(event.target));
})();
